//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React, { MutableRefObject, useEffect, useRef } from 'react';

// Inspired by https://github.com/facebook/react/issues/13029#issuecomment-522632038
export const useCombinedRefs = <T>(
  ...refs: React.Ref<T>[]
): React.RefObject<T> => {
  const targetRef = useRef<T>(null);

  useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) {
        return;
      }

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else if (targetRef.current) {
        (ref as MutableRefObject<T>).current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
};
